import { useNavigate } from "react-router-dom"

import { useDeleteIntegration } from "@/api/useIntegrations"
import { Button } from "@/atoms"
import { NAMES_ROUTES } from "@/const/routes.constants"
import { useTranslation } from "@/hooks/useTranslation"
import { DisconnectOutlined } from "@/icons"
import { DeleteConfirmModal, useConfirmModal } from "@/molecules/ConfirmModal"
import { Protected } from "@/molecules/Protected"

import type { DisconnectIntegrationResponse } from "@/api/useIntegrations.types"
import type { TicketingDisconnectButtonProps } from "./TicketingDisconnectButton.types"

export const TicketingDisconnectButton = (
  props: TicketingDisconnectButtonProps
) => {
  const { vendor, vendorName } = props
  const remover = useDeleteIntegration<DisconnectIntegrationResponse, string>({
    vendor
  })
  const { confirm } = useConfirmModal()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { t: tDisconnect } = useTranslation("translation", {
    keyPrefix: "integrations.configuration.ticketing.disconnect"
  })
  const values = { vendor: vendorName }

  const onDisconnect = () =>
    confirm((attr) =>
      DeleteConfirmModal({
        name: vendorName,
        entityName: vendor,
        content: tDisconnect("guard", values),
        okText: t("general.disconnect"),
        messages: {
          success: tDisconnect("success", values),
          error: tDisconnect("error", values)
        },
        onOk: async () => {
          // The backend ignores the resource id, so the vendor fills it
          const { data, error } = await remover.mutateAsync(vendor)

          if (!data) throw { data: { displayMessage: error } }

          navigate(`/${NAMES_ROUTES.INTEGRATIONS.ROOT}`)
        },
        ...attr
      })
    )

  return (
    <Protected shouldDisable permission={{ action: "*", resource: "*" }}>
      <Button danger icon={<DisconnectOutlined />} onClick={onDisconnect}>
        {t("general.disconnect")}
      </Button>
    </Protected>
  )
}
